// En src/hooks/usePlatformConfig.js

import { useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase';

const usePlatformConfig = () => {
    const [config, setConfig] = useState(null);
    const [loadingConfig, setLoadingConfig] = useState(true);
    const [errorConfig, setErrorConfig] = useState(null);

    useEffect(() => {
        const configRef = doc(db, 'platform_config', 'main');

        const unsubscribe = onSnapshot(configRef, (docSnap) => {
            if (docSnap.exists()) {
                setConfig(docSnap.data());
            } else {
                console.warn('Documento de configuración no encontrado.');
                setErrorConfig('No se pudo cargar la configuración de la plataforma.');
            }
            setLoadingConfig(false);
        }, (error) => {
            console.error('Error al cargar la configuración de la plataforma:', error);
            setErrorConfig('Error al cargar la configuración.');
            setLoadingConfig(false);
        });

        return () => {
            unsubscribe();
        };
    }, []); // El array vacío asegura que esto solo se ejecute una vez

    // Devolvemos un objeto con la configuración y los estados de carga/error
    return { config, loadingConfig, errorConfig };
};

export default usePlatformConfig;